module.exports = __webpack_public_path__ + "img/Rigoberta_and_Brian_with_youth.8477d7c3.jpeg";